/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './action';
import './grant';
import './channel';
import './customer_metadata';
import './decision_method';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "grantly": {
            "nested": {
              "api": {
                "nested": {
                  "Request": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "clientId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "customerId": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "status": {
                        "type": "squareup.cash.grantly.api.Request.Status",
                        "id": 4,
                        "rule": "optional"
                      },
                      "actions": {
                        "type": "squareup.cash.grantly.api.Action",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "authFlowTriggers": {
                        "type": "squareup.cash.grantly.api.AuthFlowTriggers",
                        "id": 6,
                        "rule": "optional"
                      },
                      "createdAt": {
                        "type": "uint64",
                        "id": 7,
                        "rule": "optional"
                      },
                      "updatedAt": {
                        "type": "uint64",
                        "id": 8,
                        "rule": "optional"
                      },
                      "expiresAt": {
                        "type": "uint64",
                        "id": 9,
                        "rule": "optional"
                      },
                      "referenceId": {
                        "type": "string",
                        "id": 10,
                        "rule": "optional"
                      },
                      "origin": {
                        "type": "squareup.cash.grantly.api.Request.Origin",
                        "id": 11,
                        "rule": "optional"
                      },
                      "grants": {
                        "type": "squareup.cash.grantly.api.Grant",
                        "id": 12,
                        "rule": "repeated"
                      },
                      "metadata": {
                        "type": "string",
                        "id": 13,
                        "keyType": "string"
                      },
                      "requesterProfile": {
                        "type": "squareup.cash.grantly.api.RequesterProfile",
                        "id": 14,
                        "rule": "optional"
                      },
                      "customerProfile": {
                        "type": "squareup.cash.grantly.api.CustomerProfile",
                        "id": 15,
                        "rule": "optional"
                      },
                      "redirectUrl": {
                        "type": "string",
                        "id": 16,
                        "rule": "optional"
                      },
                      "channel": {
                        "type": "squareup.cash.grantly.api.Channel",
                        "id": 17,
                        "rule": "required"
                      },
                      "customerMetadata": {
                        "type": "squareup.cash.grantly.api.CustomerMetadata",
                        "id": 18,
                        "rule": "optional"
                      },
                      "decisionMethod": {
                        "type": "squareup.cash.grantly.api.DecisionMethod",
                        "id": 19,
                        "rule": "optional"
                      },
                      "appData": {
                        "type": "squareup.cash.grantly.api.Grant.AppData",
                        "id": 20,
                        "rule": "repeated"
                      },
                      "sessionId": {
                        "type": "string",
                        "id": 21,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Status": {
                        "values": {
                          "PENDING": 1,
                          "APPROVED": 2,
                          "DECLINED": 3,
                          "PROCESSING": 4
                        }
                      },
                      "Origin": {
                        "fields": {
                          "type": {
                            "type": "squareup.cash.grantly.api.Request.Origin.Type",
                            "id": 1,
                            "rule": "optional"
                          },
                          "id": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Type": {
                            "values": {
                              "DIRECT": 1,
                              "REQUEST_INITIATOR": 2,
                              "CUSTOMER_PRESENTED_QR": 3
                            }
                          }
                        }
                      },
                      "ClearableField": {
                        "values": {
                          "REFERENCE_ID": 1,
                          "METADATA": 2
                        }
                      }
                    }
                  },
                  "AuthFlowTriggers": {
                    "fields": {
                      "qrCodeImageUrl": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "mobileUrl": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "refreshesAt": {
                        "type": "uint64",
                        "id": 3,
                        "rule": "optional"
                      },
                      "desktopUrl": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "qrCodeSvgUrl": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "mobileUniversalLinkUrl": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "mobileDeepLinkUrl": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "webUrl": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      }
                    }
                  },
                  "RequesterProfile": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 1,
                        "rule": "required"
                      },
                      "logoUrl": {
                        "type": "string",
                        "id": 2,
                        "rule": "required"
                      },
                      "darkLogoUrl": {
                        "type": "string",
                        "id": 9,
                        "rule": "optional"
                      },
                      "bizzyEntityToken": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "merchantToken": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "parentMerchantToken": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "lightBackgroundColor": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "darkBackgroundColor": {
                        "type": "string",
                        "id": 8,
                        "rule": "optional"
                      },
                      "isTemplateAvatar": {
                        "type": "bool",
                        "id": 10,
                        "rule": "optional"
                      }
                    }
                  },
                  "CustomerProfile": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "required"
                      },
                      "cashtag": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Request && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Request?.nested?.Status && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Request?.nested?.Origin && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Request?.nested?.Origin?.nested?.Type && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.Request?.nested?.ClearableField && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.AuthFlowTriggers && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.RequesterProfile && !$root.nested?.squareup?.nested?.cash?.nested?.grantly?.nested?.api?.nested?.CustomerProfile) {
  $root.addJSON(jsonData);
}

/**
 * Represents a third-party client asking a Cash customer for authorization to
 * perform a given action against the customer's account. Also known as
 * "Customer Request".
 *
 * SOURCE Request @ squareup/cash/grantly/api/request.proto at 19:1
 */
export const Request = $root.lookupType('squareup.cash.grantly.api.Request');
fixType(Request);
Builder.createAndAttachToType(Request);
/**
 * Next ID: 22
 * Represents the different statuses in a request's lifecycle:
 * PENDING -> APPROVED | DECLINED
 *
 * SOURCE Status @ squareup/cash/grantly/api/request.proto at 191:3
 */
Request.Status = $root.lookupEnum('squareup.cash.grantly.api.Request.Status').values;
/**
 * Represents the resource or actor that created a request.
 *
 * SOURCE Origin @ squareup/cash/grantly/api/request.proto at 224:3
 */
Request.Origin = $root.lookupType('squareup.cash.grantly.api.Request.Origin');
fixType(Request.Origin);
Builder.createAndAttachToType(Request.Origin);
/**
 * Next ID: 3
 * Represents a type of actor that can be responsible for creating a
 * request.
 *
 * SOURCE Type @ squareup/cash/grantly/api/request.proto at 248:5
 */
Request.Origin.Type = $root.lookupEnum('squareup.cash.grantly.api.Request.Origin.Type').values;
/**
 * Each field on the request resource that is allowed to be cleared.
 *
 * SOURCE ClearableField @ squareup/cash/grantly/api/request.proto at 274:3
 */
Request.ClearableField = $root.lookupEnum('squareup.cash.grantly.api.Request.ClearableField').values;
/**
 * Represents different methods a third-party can use to get a Cash customer
 * to initiate a review of a request.
 *
 * SOURCE AuthFlowTriggers @ squareup/cash/grantly/api/request.proto at 284:1
 */
export const AuthFlowTriggers = $root.lookupType('squareup.cash.grantly.api.AuthFlowTriggers');
fixType(AuthFlowTriggers);
Builder.createAndAttachToType(AuthFlowTriggers);
/**
 * Details about the brand or client that are requesting permission to perform
 * the actions on the customer request.
 *
 * SOURCE RequesterProfile @ squareup/cash/grantly/api/request.proto at 372:1
 */
export const RequesterProfile = $root.lookupType('squareup.cash.grantly.api.RequesterProfile');
fixType(RequesterProfile);
Builder.createAndAttachToType(RequesterProfile);
/**
 * If the customer request was approved, contains the identity of the Cash App
 * customer that approved it.
 *
 * SOURCE CustomerProfile @ squareup/cash/grantly/api/request.proto at 431:1
 */
export const CustomerProfile = $root.lookupType('squareup.cash.grantly.api.CustomerProfile');
fixType(CustomerProfile);
Builder.createAndAttachToType(CustomerProfile);